export default "__VITE_ASSET__pJjQYKlL__"